export default class AOAvailabilityPaxSelect {
  static mainSelector = '.js-tour-availability__traveller-popup';

  static paxInputSelector = '.js-scout-component-date-traveller-select__pax-selection--input';

  static mainInputSelector = '.js-scout-component-date-traveller-select__input--pax';

  static travellerSelected = false;

  constructor(common, gaEventCategory, inputIndex, paxModalId) {
    this.common = common;
    this.gaEventCategory = gaEventCategory;
    this.paxAddClass = 'js-scout-component-date-traveller-select__pax-selection--add';
    this.paxModalId = paxModalId;
    this.$paxModal = $(`#${this.paxModalId}`);
    this.INACTIVE_CLASS = 'scout-element__counter-button--inactive';
    this.inputPaxTypes = {};
    this.inputIndex = inputIndex;

    this.selectors = {
      paxAdd: '.js-scout-component-date-traveller-select__pax-selection--add',
      paxSubstract: '.js-scout-component-date-traveller-select__pax-selection--substract',
      mainInput: AOAvailabilityPaxSelect.mainInputSelector,
      title: '.js-scout-component-date-traveller-select__traveller-popup-title',
      checkbox: '.js-scout-component-date-traveller-select__travel-with-friend-checkbox',
      mobileMainCta: '.js-scout-component-date-traveller-select__mobile-cta',
      mobileCloseButton: '.js-scout-component-date-traveller-select__mobile-close',
      operatorCta: '.js-scout-component-date-traveller-select__cta-operator',
    };

    this.isHiddenClass = 'is-hidden';
    this.isMobile = false;
  }

  initiate() {
    this.isMobile = $(window).width() <= 767;

    this.initiatePaxInputValues();
    this.handleTravelWithFriend();
    this.handleApplyClick();
    this.handleCloseClick();
    this.handleOperatorCtaClick();

    this.$paxModal.on('click', `${this.selectors.paxAdd}, ${this.selectors.paxSubstract}`, (event) => {
      this.handlePaxChange(event);
    });
  }

  handlePaxChange(event) {
    const $current = $(event.currentTarget);
    const $currentInput = $current.parent().find(AOAvailabilityPaxSelect.paxInputSelector);

    if ($current.prop('disabled') || $current.hasClass(this.INACTIVE_CLASS)) {
      return;
    }

    const isAddPax = $current.hasClass(this.paxAddClass);
    this[isAddPax ? 'addPax' : 'removePax']($currentInput);
  }

  addPax($inputElement) {
    const currentValue = parseInt($inputElement.val(), 10);
    const nextValue = currentValue + 1;

    $inputElement.val(nextValue);
    this.adjustPax($inputElement, this.isMobile);

    this.common.sendGoogleEvent(
      this.gaEventCategory,
      'Traveller Added',
      `${$inputElement.data('ga-label')}-${$inputElement.val()}`,
    );
  }

  removePax($inputElement) {
    const currentValue = parseInt($inputElement.val(), 10);
    const nextValue = currentValue - 1;

    $inputElement.val(nextValue);
    this.adjustPax($inputElement, this.isMobile);

    this.common.sendGoogleEvent(
      this.gaEventCategory,
      'Traveller Removed',
      `${$inputElement.data('ga-label')}-${$inputElement.val()}`,
    );
  }

  adjustPax($inputElement, preventUpdate = false) {
    const max = parseInt($inputElement.prop('max'), 10);
    const min = parseInt($inputElement.prop('min'), 10);

    const currentValue = parseInt($inputElement.val(), 10);
    const currentTitle = AOAvailabilityPaxSelect.getTitleFromInput($inputElement);
    const currentId = $inputElement.attr('id');
    const priceCategoryId = parseInt($inputElement.data('price-category-id'), 10);

    const $title = $(this.selectors.title).filter(`[data-price-category-id="${priceCategoryId}"]`);
    const $inputContainer = $inputElement.parent();
    const $addButton = $inputContainer.find(this.selectors.paxAdd);
    const $substractButton = $inputContainer.find(this.selectors.paxSubstract);

    $addButton.removeClass(this.INACTIVE_CLASS).prop('disabled', false);
    $substractButton.removeClass(this.INACTIVE_CLASS).prop('disabled', false);

    if (currentValue >= max) {
      $inputElement.val(Math.min(currentValue, max));
      $(this.selectors.mainInput).eq(this.inputIndex).focus();
      $addButton.addClass(this.INACTIVE_CLASS).prop('disabled', true);
    }

    if (currentValue <= min) {
      $inputElement.val(Math.max(currentValue, min));
      $(this.selectors.mainInput).eq(this.inputIndex).focus();
      $substractButton.addClass(this.INACTIVE_CLASS).prop('disabled', true);
    }

    $title.text(currentTitle);

    if (!preventUpdate) {
      this.updatePaxSelectorInput(currentId, currentValue, currentTitle);
    }
  }

  initiatePaxInputValues() {
    $(`#${this.paxModalId}`)
      .find(AOAvailabilityPaxSelect.paxInputSelector)
      .forEach((item) => {
        const $item = $(item);
        const itemId = $item.attr('id');
        const itemValue = $item.val();
        const itemTitle = AOAvailabilityPaxSelect.getTitleFromInput($item);

        if (itemValue > 0) {
          this.updatePaxSelectorInput(itemId, itemValue, itemTitle);
        }
      });
  }

  updatePaxSelectorInput(id, value, title) {
    this.inputPaxTypes[id] = {
      value, title,
    };

    if (value < 1) {
      delete this.inputPaxTypes[id];
    }

    const allTravelers = Object.values(this.inputPaxTypes).map((item) => `${item.value} ${item.title}`).join(', ');
    $(this.selectors.mainInput).eq(this.inputIndex).val(allTravelers);
  }

  static getTitleFromInput($inputElement) {
    const singularTitle = $inputElement.data('price-category-title-singular') || 'Traveler';
    const pluralTitle = $inputElement.data('price-category-title-plural') || 'Travelers';
    const currentValue = parseInt($inputElement.val(), 10);

    return currentValue > 1 ? pluralTitle : singularTitle;
  }

  static getPaxSelectorValue(selectorGroupName) {
    const $paxValue = $(`#${selectorGroupName}PaxInput`).val();
    return $paxValue;
  }

  static getValues(selectorGroupName) {
    const $modalInput = $(`#${selectorGroupName}`).find(AOAvailabilityPaxSelect.paxInputSelector);
    if (!$modalInput.length) {
      return [];
    }

    const paxTypes = [];
    let paxNumber = 0;

    $modalInput.forEach((element) => {
      const selected = parseInt($(element).val(), 10);

      for (let i = 0; i < selected; i += 1) {
        paxNumber += 1;
        paxTypes.push({
          price_category_id: parseInt($(element).data('price-category-id'), 10),
          pax_number: paxNumber,
        });
      }
    });

    return paxTypes;
  }

  static getMainButton() {
    return $('.js-scout-component-date-traveller-select__mobile-cta');
  }

  syncPaxInputs(donorSelectorGroupName) {
    const localSelectorGroupName = donorSelectorGroupName === 'mainBlock' ? 'priceBlock' : 'mainBlock';
    const localPaxCounterInputs = $(`#${localSelectorGroupName}`).find(AOAvailabilityPaxSelect.paxInputSelector);

    $(`#${donorSelectorGroupName}`).find(AOAvailabilityPaxSelect.paxInputSelector).forEach((item, i) => {
      const $item = $(item);
      const itemId = $item.attr('id');
      const itemValue = $item.val();
      const itemTitle = AOAvailabilityPaxSelect.getTitleFromInput($item);

      localPaxCounterInputs.eq(i).val(itemValue);
      this.updatePaxSelectorInput(itemId, itemValue, itemTitle);
    });
  }

  handleTravelWithFriend() {
    const $eligblePaxSelector = $(AOAvailabilityPaxSelect.paxInputSelector).eq(this.inputIndex);
    const $travelWithFriendCheckbox = $(`${this.selectors.checkbox} input[type="checkbox"]`);
    const initialMinValue = $eligblePaxSelector.prop('min');
    const currentPriceCategoryId = $eligblePaxSelector.data('price-category-id');
    const $substractButton = $(this.selectors.paxSubstract);
    const title = AOAvailabilityPaxSelect.getTitleFromInput($eligblePaxSelector);

    if (!this.$paxModal.data('travel-with-friend')) {
      return;
    }

    $travelWithFriendCheckbox.on('change', (event) => {
      if ($(event.currentTarget).prop('checked')) {
        $eligblePaxSelector.prop('min', 1);
        $substractButton.removeClass(this.INACTIVE_CLASS).prop('disabled', false);
        this.common.sendGoogleEvent(this.gaEventCategory, 'Travelling with a friend', '2 Travellers Required');

        $(this.selectors.operatorCta).toggleClass('hid', true);
      } else {
        $eligblePaxSelector.prop('min', initialMinValue);

        if ($eligblePaxSelector.val() < initialMinValue) {
          $substractButton.addClass(this.INACTIVE_CLASS).prop('disabled', true);
          this.updatePaxSelectorInput(currentPriceCategoryId, initialMinValue, title);
          $eligblePaxSelector.val(initialMinValue);
        }

        $(this.selectors.operatorCta).toggleClass('hid', false);
      }
    });

    this.common.sendGoogleEvent(this.gaEventCategory, 'Information Shown', '2 Travellers Required');
  }

  handleOperatorCtaClick() {
    const $modal = $(AOAvailabilityPaxSelect.mainSelector);
    const { isHiddenClass } = this;
    const $operatorCta = $(this.selectors.operatorCta);

    if (!$operatorCta.length) {
      return;
    }

    $operatorCta.on('click', () => {
      $modal.addClass(isHiddenClass);
      $('body').removeClass('scrim');
      $('.js-ao-tour-start-planning-your-tour__cta-ask').first().click();

      this.common.sendGoogleEvent(this.gaEventCategory, 'Contact Operator', '2 Travellers Required');
    });
  }

  handleApplyClick() {
    const $mobileMainCta = $(`#${this.paxModalId}`).find(this.selectors.mobileMainCta);
    const { isHiddenClass } = this;
    const $modal = $(`#${this.paxModalId}`);

    if (!$mobileMainCta.length) {
      return;
    }

    $mobileMainCta.on('click', () => {
      this.initiatePaxInputValues();
      const passengers = AOAvailabilityPaxSelect.getPaxSelectorValue(this.paxModalId);

      $modal.addClass(isHiddenClass);
      $('body').removeClass('scrim layer');

      this.common.sendGoogleEvent(
        this.gaEventCategory,
        'Apply CTA - Pax Selector',
        passengers,
      );
    });
  }

  handleCloseClick() {
    const $mobileCloseButton = $(`#${this.paxModalId}`).find(this.selectors.mobileCloseButton);
    const { isHiddenClass } = this;
    const $modal = $(`#${this.paxModalId}`);

    if (!$mobileCloseButton.length) {
      return;
    }

    $mobileCloseButton.on('click', () => {
      $modal.addClass(isHiddenClass);

      Object.keys(this.inputPaxTypes).forEach((paxType) => {
        const paxValue = this.inputPaxTypes[paxType].value;
        $(`input[data-price-category-id="${paxType}"]`).val(paxValue);
      });

      $('body').removeClass('scrim layer');
    });
  }
}
